import { TextField } from "../common/input/TextField";
import classes from "./ContactForm.module.scss";
import { PrimaryButton } from "../disease_knowledge/components/PrimaryButton";
import { SubButton } from "../common/button/SubButton";
import { useForm, Controller } from "react-hook-form";
import { RequiredLabel } from "../common/input/RequiredLabel";
import React, { useState } from "react";
import { orderErrorToast } from "../../funcs/orderResultToast";
import { FullScreenLoading } from "../common/FullScreenLoading";

export function ContactForm({ onSubmit, onCancel }: Props) {

    const {
        handleSubmit,
        control,
        setError,
        formState: { errors },
    } = useForm<ContactForm>();

    const [loading, setLoading] = useState(false);

    const submitWrapper = async (form: ContactForm) => {
        setLoading(true);
        try {
            await onSubmit(form);
        } catch(e) {
            const { code } = e as { code: number };
            if (code === 409) {
                setError("email", {
                    type: "validate",
                    message: "メールアドレスがすでに連絡先に登録されています"
                });
            } else if (code === 401) {
                window.location.href = "/login";
            } else {
                orderErrorToast("連絡先登録に失敗しました。");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit(submitWrapper)} className={classes.form}>
            {loading && <FullScreenLoading />}
            <div className={classes.label}>メールアドレス<RequiredLabel /></div>
            <div className={classes.input}>
                <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    rules={{
                        required: "メールアドレスは必須です",
                        pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "メールアドレスの形式が不正です"
                        }
                    }}
                    render={({ field }) => (
                        <>
                            <TextField value={field.value} onChange={field.onChange} placeholder={"test@example.com"} />
                            {errors.email && <p className={classes.errorMessage}>{errors.email.message}</p>}

                        </>
                    )}
                />
            </div>
            <div className={classes.label}>名前<RequiredLabel /></div>
            <div className={classes.input}>
                <Controller
                    name="name"
                    control={control}
                    defaultValue=""
                    rules={{
                        required: "名前は必須です",
                    }}
                    render={({ field }) => (
                        <>
                            <TextField value={field.value} onChange={field.onChange} placeholder={"田中太郎"}/>
                            {errors.name && <p className={classes.errorMessage}>{errors.name.message}</p>}
                        </>
                    )}
                />
            </div>
            <div className={classes.label}>電話番号1<RequiredLabel /></div>
            <div className={classes.input}>
                <Controller
                    name="tel1"
                    control={control}
                    defaultValue=""
                    rules={{
                        required: "電話番号1は必須です",
                        pattern: {
                            value: /^[0-9０-９\-ー]{1,20}$/,
                            message: "電話番号は数字とハイフン（-, ー)のみで入力してください",
                        }
                    }}
                    render={({ field }) => (
                        <>
                            <TextField value={field.value} onChange={field.onChange} placeholder={"09012345678"} maxLength={20}/>
                            {errors.tel1 && <p className={classes.errorMessage}>{errors.tel1.message}</p>}
                        </>
                    )}
                />
            </div>
            <div className={classes.label}>電話番号2</div>
            <div className={classes.input}>
                <Controller
                    name="tel2"
                    control={control}
                    defaultValue=""
                    rules={{
                        pattern: {
                            value: /^[0-9０-９\-ー]{1,20}$/,
                            message: "電話番号は数字とハイフン（-, ー)のみで入力してください",
                        }
                    }}
                    render={({ field }) => (
                        <>
                            <TextField value={field.value} onChange={field.onChange} placeholder={"09012345678"} maxLength={20}/>
                            <p>{errors.tel2 && <p className={classes.errorMessage}>{errors.tel2.message}</p>}</p>
                        </>
                    )}
                />
            </div>
            <div className={classes.label}>ラベル<RequiredLabel /></div>
            <div className={classes.input}>
                <Controller
                    name="label"
                    control={control}
                    defaultValue=""
                    rules={{
                        required: "ラベル（家族・介護事業所など）を入力してください"
                    }}
                    render={({ field }) => (
                        <>
                            <TextField value={field.value} onChange={field.onChange} placeholder={"ご家族"} maxLength={50}/>
                            {errors.label && <p className={classes.errorMessage}>{errors.label.message}</p>}
                        </>
                    )}
                />
            </div>
            <div className={classes.button}>
                <PrimaryButton type={"submit"} width={150}>
                    登録
                </PrimaryButton>
                <SubButton width={"150px"} onClick={onCancel}>
                    キャンセル
                </SubButton>
            </div>
        </form>
    );
}

type Props = {
    onSubmit: (form: ContactForm) => Promise<any>;
    onCancel: () => void;
}

export type ContactForm = {
    email: string,
    name: string,
    label: string,
    tel1: string,
    tel2: string,
};
